<script>
import * as PusherPushNotifications from '@pusher/push-notifications-web';
import { mapState } from 'vuex';

export default {
    name: 'PushNotifications',
    computed: {
        ...mapState('Auth', { user: state => state.user }),
        hasActiveAttempt() {
            return this.$store.getters['User/hasActiveAttempt'] || this.$route.name === 'automated-survey-attempt';
        },
    },
    async created() {
        if (this.hasActiveAttempt || !this.$hasFeature('PUSH_NOTIFICATIONS')) return;

        try {
            const beamsClient = new PusherPushNotifications.Client({
                instanceId: import.meta.env.VITE_PUSHER_BEAMS_INSTANCE_ID,
            });

            const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
                url: '/api/pusher/beams-auth',
            });

            const beamsUserId = await beamsClient.getUserId().catch(() => null);

            if (beamsUserId !== this.user.id.toString()) {
                await beamsClient.stop();
            }

            await beamsClient.start();
            await beamsClient.setUserId(this.user.id.toString(), beamsTokenProvider);
            await beamsClient.getDeviceInterests();
        } catch (error) {
            console.error(error);
        }
    },
    render: () => null,
};
</script>
